import type { Rule } from './types';

export const semanticRules: Rule[] = [
  {
    id: 'triggers.canonical-coverage',
    category: 'triggers',
    severity: 'warn',
    weight: 4,
    title: 'Matches canonical user phrasings',
    appliesTo: 'both',
    run(ctx) {
      const matched = ctx.semantic.matchedCount;
      const total = ctx.semantic.canonicalCount;
      if (matched >= 4) return { status: 'pass', message: `Matches ${matched} of ${total} canonical user phrasings.` };
      if (matched >= 2) return { status: 'pass', message: `Matches ${matched} canonical phrasings.` };
      if (matched === 1) {
        return {
          status: 'warn',
          message: `Only 1 canonical user-phrasing match.`,
          fix: 'Add more concrete user phrasings to your description. Mirror language users actually type.',
        };
      }
      return {
        status: 'warn',
        message: 'Description does not lexically overlap with any canonical user phrasing.',
        fix: 'Quote phrasings users would say verbatim. Echo verb+object patterns ("create X", "review Y").',
      };
    },
  },
  {
    id: 'triggers.semantic-density',
    category: 'triggers',
    severity: 'info',
    weight: 2,
    title: 'Strong semantic signal in top matches',
    appliesTo: 'both',
    run(ctx) {
      const m = ctx.semantic.meanTopSimilarity;
      if (m >= 0.5) return { status: 'pass', message: `Mean top-5 similarity ${(m * 100).toFixed(0)}%.` };
      if (m >= 0.3) return { status: 'pass', message: `Mean top-5 similarity ${(m * 100).toFixed(0)}%.` };
      if (m === 0) return { status: 'skipped', message: 'No matches at all.' };
      return {
        status: 'warn',
        message: `Top semantic matches are weak (${(m * 100).toFixed(0)}%).`,
        fix: 'Phrasings are loosely related, not concrete. Use direct user verbs and objects.',
      };
    },
  },
];
